import { ThemeBlueprint } from '@backstage/plugin-app-react';
import {
  CfaDarkThemeProvider,
  CfaLightThemeProvider,
} from './cfaThemeShell';

const cfaLightThemeExtension = ThemeBlueprint.make({
  name: 'cfaLight',
  params: {
    theme: {
      id: 'cfaLight',
      title: 'CFA Light',
      variant: 'light',
      Provider: ({ children }) => (
        <CfaLightThemeProvider>{children}</CfaLightThemeProvider>
      ),
    },
  },
});

const cfaDarkThemeExtension = ThemeBlueprint.make({
  name: 'cfaDark',
  params: {
    theme: {
      id: 'cfaDark',
      title: 'CFA Dark',
      variant: 'dark',
      Provider: ({ children }) => (
        <CfaDarkThemeProvider>{children}</CfaDarkThemeProvider>
      ),
    },
  },
});

export { cfaLightThemeExtension, cfaDarkThemeExtension };
